import weixin from './weixin.js'
import sms from './sms.js'
import automatic from './automatic.js'

export default {
  weixin,
  sms,
  automatic
}
